<template>
    <v-overlay :modelValue=true class="align-center justify-center" style="z-index: 999999;">
        <v-progress-circular color="pacificBlue" indeterminate size="100"><strong>Loading</strong></v-progress-circular>
    </v-overlay>
</template>

<script lang="ts">
export default {}
</script>